import { ChangePercentage, ChangePercentageBackward } from "app/components/React/Table/cells/ChangePercentage";
import type { CellSchema } from "app/pages/benchmark-tracker/components/Report/MetricElements/TableView/type";

export const CustomChangeCell = ({ row, value }: CellSchema) =>
    row?.isInverted ? (
        <ChangePercentageBackward
            value={value}
            row={row}
        />
    ) : (
        <ChangePercentage
            value={value}
            row={row}
        />
    );
